module.exports = __webpack_public_path__ + "static/img/gzhcode.54613e5c.jpg";